// Module
var code = "<script>let $ctrl</script> <div class=\"atom-text-bubble\" ng-class=\"{blue: $ctrl.color=='blue', grey: $ctrl.color=='grey'}\"> <atom-text modifier=\"{{ $ctrl.textModifier }}\"> <ng-transclude></ng-transclude> </atom-text> </div> ";
// Exports
module.exports = code;